<template>
  <div>
  
  <div style="position: relative;">
    <img src="..//assets/index.jpg" style=" max-height: 100%; max-width: 100%; "/>
  </div>


    <el-main  v-loading.fullscreen.lock="loading">     
       <el-card  class="div1" style="width:90%">
          <div slot="header" class=" clearfix">         
            <span style="font-weight: bold;">{{$t('field.announcement')}}</span>
          </div>
          <div>    
            <ul>
              <li v-for="(item, index) in announcementList" :key="index">
                <el-link type="primary" @click.native=clickAnnounce(item)>{{ item.title }} </el-link>
              </li>
            </ul>          
          </div>
        </el-card>
        <div v-if="isCust"><br></div>
     
        <el-card  class="div2" style="width:90%" v-if="isCust">
          <div slot="header" class="clearfix" >         
            <span style="font-weight: bold;">{{$t('field.reminder')}}</span>
          </div>
          <div>
            <!--
            <li>{{$t('msg.newShipmentReminder')}} <br><span style="color:darkred;white-space: pre-line;white-space:pre;">{{$t('field.invoiceNo')}}:<br>{{invoiceStr}}</span></li>
            <li>
              {{$t('msg.softwareDocumentUpdReminder')}}<br><span style="color:darkred;white-space: pre-line;white-space:pre;">{{$t('field.software')}}:<br>{{swfwUpdStr}}<br>
              {{$t('field.document')}}:<br> {{docUpdStr}}</span>
            </li>
             -->
            <li>{{$t('msg.majorUpdReminder')}}<br><span style="color:darkred;white-space: pre-line;white-space:pre;"> {{$t('field.software')}}:<br>{{importUpdStr}}</span></li>
            <li>{{$t('msg.newRMANoReminder')}}<br><span style="color:darkred;white-space: pre-line;white-space:pre;">  RMA no.:<br>{{rmaStr}}</span></li>
          </div>
        </el-card>
        <br v-if="!isCust">
         <el-card  class="div2" style="width:90%" v-if="!isCust">
          <div slot="header" class="clearfix" >         
            <span style="font-weight: bold;">{{$t('field.reminder')}}</span>
          </div>
          <div>  
        
            <li>{{$t('field.feedbackTasks')}} ：{{feedbackStr}}</li>
            <li>{{$t('field.csNewMsg')}} ：{{newMsgStr}}</li>
            <li>{{$t('field.csPersonalTasks')}} ：{{csTodoStr}}</li>
            <li>{{$t('field.crPersonalTasks')}} ：{{crTodoStr}}</li>
            <li>{{$t('field.fillEcrEcn')}} ：{{ecrEcnStr}}</li>
            <li>{{$t('field.cncPersonalTasks')}} ：{{cncTodoStr}}</li>
          </div>
        </el-card>

        <br v-if="!isCust">
        <el-card  class="div4" style="width:90%" v-if="!isCust">
          <div slot="header" class="clearfix" >         
            <span style="font-weight: bold;">{{$t('menu.statTarget')}}</span>
          </div>
          <div>  
            <el-row :gutter="12" >
              <el-col :span="8" >      
                <el-col :span="8" style="text-align: right;">   
                  <font-awesome-icon icon="users"  size="3x" :style="{ color: '#e88a2a' }"/>
                </el-col>
                <el-col :span="16" >  
                  {{$t('field.statTarget1_1_1')}} <font class="importantFont">{{customerCnt}}</font> {{$t('field.statTarget1_1_2')}} <br>             
                  {{$t('field.statTarget1_2_1')}} <font class="importantFont">{{countryCnt}}</font> {{$t('field.statTarget1_2_2')}} 
                </el-col>               
              </el-col>
              <el-col :span="8" >
                <el-col :span="8" style="text-align: right;"> 
                  <font-awesome-icon icon="phone-volume" size="3x" :style="{ color: '#3493bd' }" />
                </el-col>
                <el-col :span="16" >  
                  {{$t('field.statTarget2_1_1')}} <font class="importantFont">{{feedbackCnt}}</font> {{$t('field.statTarget2_1_2')}} <br>             
                  {{$t('field.statTarget2_2_1')}} <font class="importantFont">{{totalFeedbackCnt}}</font> {{$t('field.statTarget2_2_2')}} 
                </el-col>
       
               
              </el-col>
              <el-col :span="8" >
                <el-col :span="8" style="text-align: right;"> 
                  <font-awesome-icon icon="wrench" size="3x"   :style="{ color: '#51a755' }" />
                </el-col>
                <el-col :span="16" >  
                  {{$t('field.statTarget3_1_1')}} <font class="importantFont">{{rmaCnt}}</font> {{$t('field.statTarget3_1_2')}} <br>             
                  {{$t('field.statTarget3_2_1')}} <font class="importantFont">{{totalRmaCnt}}</font> {{$t('field.statTarget3_2_2')}}
                </el-col>
            
               
              </el-col>
            </el-row>
          </div>
        </el-card>
        <br >
        <el-card  class="div3" style="width:90%">
          <div slot="header" class="clearfix" >         
            <span style="font-weight: bold;">{{$t('field.systemFunction')}}</span>
          </div>
          <div>
           {{$t('field.systemFunctionDesc')}}<br><br>
            <el-row :gutter="20">	
              <el-col :span="6">
                <el-card class="box-card" shadow="hover">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-mobile-phone card-icon"></i>&nbsp;&nbsp;
                    <span><el-link type="primary" @click="$router.push('/productList')">{{$t('menu.productList')}}</el-link></span>
                  </div>
                  {{$t('field.systemFunctionProductListDesc')}}<br>
                  <el-link type="primary" @click="downloadTutorial('購貨查詢&收貨(中文).pdf')">{{$t('field.stepByStep')}}(中文)</el-link><br>                  
                  <el-link type="primary" @click="downloadTutorial('Buying List(Eng).pdf')">{{$t('field.stepByStep')}}(English)</el-link> 
                </el-card>
              </el-col>
              <el-col :span="6">
                <el-card class="box-card" shadow="hover">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-phone-outline card-icon"></i>&nbsp;&nbsp;
                    <span><el-link type="primary" @click="$router.push('/CreateFeedback')">{{$t('menu.createFeedback')}}</el-link></span>
                  </div>
                  {{$t('field.systemFunctionCreateFeedbackDesc')}}<br>
                  <el-link type="primary" @click="downloadTutorial('問題回報(中文).pdf')">{{$t('field.stepByStep')}}(中文)</el-link><br>                  
                  <el-link type="primary" @click="downloadTutorial('Create feedback(Eng).pdf')">{{$t('field.stepByStep')}}(English)</el-link>  
                </el-card>
              </el-col>
              <el-col :span="6">
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                  <i class="el-icon-download card-icon"></i>&nbsp;&nbsp;
                  <span><el-link type="primary" @click="$router.push('/installedSwFwList')">{{$t('menu.installedSwFwList')}}</el-link></span>
                </div>
                {{$t('field.systemFunctionInstalledSwFwListDesc')}}<br>
                <el-link type="primary" @click="downloadTutorial('檔案下載(中文).pdf')">{{$t('field.stepByStep')}}(中文)</el-link><br>                  
                <el-link type="primary" @click="downloadTutorial('Download(Eng).pdf')">{{$t('field.stepByStep')}}(English)</el-link> 
              </el-card>
            </el-col>
          </el-row>
          <br>
          <el-row :gutter="20">	
            <el-col :span="6">
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                  <i class="el-icon-s-platform card-icon"></i>&nbsp;&nbsp;
                  <span><el-link type="primary" @click="$router.push('/createinstalledMachine')">{{$t('menu.installedMachine')}}</el-link></span>
                </div>
                {{$t('field.systemFunctionInstalledMachineDesc')}}<br>
                <el-link type="primary" @click="downloadTutorial('裝機回報(中文).pdf')">{{$t('field.stepByStep')}}(中文)</el-link><br>                  
                <el-link type="primary" @click="downloadTutorial('Installation Reply(Eng).pdf')">{{$t('field.stepByStep')}}(English)</el-link> 
              </el-card>
            </el-col>
            <el-col :span="6"> 
              <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <i class="el-icon-s-order card-icon"></i>&nbsp;&nbsp;
                <span><el-link type="primary" @click="$router.push('/installedMachineList')">{{$t('menu.installedMachineList')}}</el-link></span>
              </div>
                {{$t('field.systemFunctionInstalledMachineListDesc')}}<br>
                <el-link type="primary" @click="downloadTutorial('裝機查詢與驗收(中文).pdf')">{{$t('field.stepByStep')}}(中文)</el-link><br>                  
                <el-link type="primary" @click="downloadTutorial('Installation Machine Tracking List(Eng).pdf')">{{$t('field.stepByStep')}}(English)</el-link> 
              </el-card>
            </el-col>
          </el-row>
          </div>
        </el-card>
        <br>
        {{$t('field.SystemAdministrator')}}<br>
        <li>蔡尚益 Ian</li>
        <li>楊曜彰 William</li>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" @opened="openAnnounceDialog" @closed="closeAnnounceDialog" >         
          <p id="dialogContent" style="word-break: break-word;"></p> 
          <img :src="dialogPic" alt="" style=" max-height: 100%; max-width: 100%; "/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">{{$t('button.confirm')}}</el-button>
          </span>
        </el-dialog>
    </el-main>
  </div>
</template>

<script>

import { apiAnnouncementByRole, apiGetShippingListByCustNo, apiFindSwfwListByCustIdAndAccount,apiFindSwfwImportantListByCustIdAndAccount
      ,apiFindDockListByCustIdAndAccount, apiGetFeedbackRmaStrByFeedbackId,apiGetCrPersonalTasks,apiGetCncPersonalTasks,
      apiGetCustomerCnt, apiGetCountryCnt, apiGetFeedbackMonthlyCnt, apiGetTotalFeedbackCnt,apiGetRmaCntMonthly, apiGetTotalRmaCnt,
      apiFindNewCsByLoginId, apiFindNewCsMsgByLoginId, apiFindCsTodoByLoginId, apiFindEcrEcnTodoByLoginId } from "../utils/api.js";
import authHeader from "../services/auth-header";
import AWSUtil from "../utils/AWSUtil";
import axios from 'axios';
const AWS = require('aws-sdk')

AWS.config.update({
  region: AWSUtil.getBucketRegion(),
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWSUtil.getIdentityPoolId()
  })
});
var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: AWSUtil.getAlbumBucketName() },
  httpOptions: {
		timeout: 30*1000*60,
	},
});

export default {
  name: 'Home',
  data() {
    return {
      imgUrlPath:AWSUtil.getUrlPath(),
      loading:false,
      invoiceStr: '',
      swfwUpdStr:'',
      docUpdStr:'',
      importUpdStr:'',
      rmaStr:'',
      isCust:false,
      announcementList:[],
      dialogVisible: false,
      dialogTitle:'',
      dialogContent:'',
      dialogPic: '',
      crTodoStr:'',
      cncTodoStr:'',
      feedbackStr:'',
      newMsgStr:'',
      csTodoStr:'',
      ecrEcnStr:'',
      noUpd:' No update',
      prefixSpace:'          ',
      customerCnt:'0',
      countryCnt:'0',
      feedbackCnt:'0',
      totalFeedbackCnt:'0',
      rmaCnt:'0',
      totalRmaCnt:'0'
    };
  },
  mounted() {    
    this.getLastMonth();


    this.isCust = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;   
    apiAnnouncementByRole({ headers: authHeader(), role: this.isCust?'CUSTOMER':'OA'}).then((response) => {         
      this.announcementList = response.data;
    }).catch((err) => {  console.log(err);  });
    if(this.isCust){
      apiGetShippingListByCustNo({ headers: authHeader()}).then((response) => {
        if(response.data!= null && response.data.length > 0){
          this.invoiceStr = this.prefixSpace + response.data[0].invoiceNo.replaceAll(';','\n' + this.prefixSpace);
        }else{
          this.invoiceStr = this.prefixSpace + this.noUpd;
        }         
        
      }).catch((err) => {  console.log(err);  });

      apiFindSwfwListByCustIdAndAccount({ headers: authHeader()}).then((response) => {       
        if(response.data != null && response.data != ''){
          this.swfwUpdStr = this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        }else{
          this.swfwUpdStr = this.prefixSpace + this.noUpd;
        }

        
      }).catch((err) => {  console.log(err);  });

      apiFindSwfwImportantListByCustIdAndAccount({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.importUpdStr = this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        }else{
          this.importUpdStr = this.prefixSpace + this.noUpd;
        }        
      }).catch((err) => {  console.log(err);  });

      apiFindDockListByCustIdAndAccount({ headers: authHeader()}).then((response) => {    
        if(response.data != null && response.data != ''){
          this.docUpdStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        }else{
          this.docUpdStr = this.prefixSpace + this.noUpd;
        }     
        
      }).catch((err) => {  console.log(err);  });
      apiGetFeedbackRmaStrByFeedbackId({ headers: authHeader()}).then((response) => {  
        if(response.data != null && response.data != ''){
          this.rmaStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else{
          this.rmaStr= this.prefixSpace + this.noUpd;
        }
        
      }).catch((err) => {  console.log(err);  });
      
    }else{


        apiFindNewCsByLoginId({ headers: authHeader()}).then((response) => {   
          if(response.data != null && response.data != ''){
            this.feedbackStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
          } else{
            this.feedbackStr= this.prefixSpace + this.noUpd;
          }        
        }).catch((err) => {  console.log(err);  });

      apiFindNewCsMsgByLoginId({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.newMsgStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else{
          this.newMsgStr= this.prefixSpace + this.noUpd;
        }        
      }).catch((err) => {  console.log(err);  });

      apiFindCsTodoByLoginId({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.csTodoStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else{
          this.csTodoStr= this.prefixSpace + this.noUpd;
        }        
      }).catch((err) => {  console.log(err);  });

      apiFindEcrEcnTodoByLoginId({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.ecrEcnStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else{
          this.ecrEcnStr= this.prefixSpace + this.noUpd;
        }        
      }).catch((err) => {  console.log(err);  });

      apiGetCrPersonalTasks({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.crTodoStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else{
          this.crTodoStr= this.prefixSpace + this.noUpd;
        }
        
      }).catch((err) => {  console.log(err);  });

      apiGetCncPersonalTasks({ headers: authHeader()}).then((response) => {   
        if(response.data != null && response.data != ''){
          this.cncTodoStr= this.prefixSpace + response.data.replaceAll(',','\n' + this.prefixSpace);
        } else {
          this.cncTodoStr= this.prefixSpace + this.noUpd;
        }
        
      }).catch((err) => {  console.log(err);  });




      apiGetCustomerCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.customerCnt = response.data;
        }
      }).catch((err) => { console.log(err); });

      apiGetCountryCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.countryCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetFeedbackMonthlyCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.feedbackCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetTotalFeedbackCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.totalFeedbackCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetRmaCntMonthly({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.rmaCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetTotalRmaCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.totalRmaCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    
  },
  methods:{
    clickAnnounce(data){      
      this.dialogTitle = data.title;
      this.dialogContent = data.content;    
      if(data.content.indexOf('{imgpath:') >-1){
        let arr = data.content.split('{imgpath:');
        if(arr!= null && arr.length >1){
          this.dialogContent = arr[0];    
          let imgPath = arr[1].substring(0,arr[1].indexOf('}'));          
          this.dialogPic= AWSUtil.getUrlPath()+'other/announcement/'+imgPath;//require('..//assets/announce/'+imgPath)
        }
      }else{
        this.dialogPic = '';
      }
      this.dialogVisible= true;
      
    },
    openAnnounceDialog(){
      var element = document.getElementById('dialogContent');
      element.innerHTML = this.dialogContent;
    },
    closeAnnounceDialog(){
      this.dialogContent = '';    
      this.dialogPic='';
      var element = document.getElementById('dialogContent');
      element.innerHTML = this.dialogContent;
    },
    downloadTutorial(fileName){
      this.fullscreenLoading = true;
      var folder = 'cust/other/training/' + fileName;
      const getFile = s3.getObject({Bucket: AWSUtil.getAlbumBucketName(), Key: folder}).promise();  

      getFile.then((data) => {   
          this.fullscreenLoading = false;
          const url = window.URL.createObjectURL(new Blob([data.Body]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }).catch((err) => {   
          this.fullscreenLoading = false;
          return alert("There was an error downloading your file: ", err.message);
        });
    }, 
    getLastMonth(){
      // var a = '202101';
      // var b = a.substring(0,4)+'-'+a.substring(4.6);
      // debugger
      // var minDate = new Date('2019-12-01'); 
      // var maxDate = new Date('2021-02-01');      
      // if (minDate && maxDate) {
      //   let minYear = minDate.getFullYear();
      //   let minMonth = minDate.getMonth()+1;
      //   let maxYear = maxDate.getFullYear();
      //   let maxMonth = maxDate.getMonth()+1;
      //   var  a = (maxYear*12 + maxMonth) - (minYear*12 + minMonth) + 1        
      // } else {
      //   return ''
      // }

    }
  }
};
</script>
<style>
  .text {
    font-size: 14px;
  }

  .card-icon {
    color: #50719a;
    font-size: 20px;
  }
 .el-card.div1  .el-card__body {
    padding: 6px;
  }
.el-card.div1 .el-card__header {
    padding: 8px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    background-color:#BFD8D2;
}

.el-card.div2   .el-card__body {
    padding: 6px;
  }
.el-card.div2  .el-card__header {
    padding: 8px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    background-color:#FEDCD2;
}

.el-card.div3 .el-card__body {
    padding: 6px;
  }
.el-card.div3 .el-card__header {
    padding: 8px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    background-color:#f5c846;
}

.el-card.div4 .el-card__body {
    padding: 6px;
  }
.el-card.div4 .el-card__header {
    padding: 8px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    background-color:#b2d8f7;
}

.el-card.box-card  .el-card__body {
    padding: 6px;
  }
.el-card.box-card  .el-card__header {
    padding: 8px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 16px;
    background-color:#fff;
} 

.normalFont {
  font-size: 14px; 
  text-align:center;
}

.importantFont{
  font-size: 25px; 
  color: #e82a2a;
}
</style>